module.exports = __webpack_public_path__ + "img/worst.15763cd0.svg";